export default "__VITE_PUBLIC_ASSET__975c981d__"